import { FC, ReactNode } from 'react';

import { Loading } from '@shared/components/Loading';
import { useSearchParams } from 'react-router-dom';

import { GiftStoreGateNotice } from './GiftStoreGateNotice';
import { useGiftStoreAccess } from '../hooks/useGiftStoreAccess';

/**
 * 답례품 "구매" 진입점(카탈로그/상세/장바구니/결제)을 감싸는 게이트.
 * - bugoId 없음 → 부고 링크 안내
 * - bugoId는 있으나 부고 없음(만료/오타) → 유효하지 않은 링크 안내
 * - 발인 후 30일 초과 → 온라인 주문 마감 안내 (전화 주문 유도)
 * - 그 외 → children 정상 렌더
 *
 * 이 게이트가 useBugoHook을 호출하는 유일한 지점이 되도록, 자식 페이지는
 * 부고 데이터를 재조회하지 않고 이미 채워진 recoil atom을 읽어 쓴다.
 *
 * 주문내역(orders)·주문 상세 등 "조회" 경로는 마감 후에도 봐야 하므로 감싸지 않는다.
 */
const GiftStorePurchaseGate: FC<{ children: ReactNode }> = function GiftStorePurchaseGate({
  children,
}) {
  const [searchParams] = useSearchParams();
  const bugoId = searchParams.get('bugoId');
  const { access, deceasedName } = useGiftStoreAccess(bugoId);

  if (access === 'loading') {
    return (
      <div className="center-box h-screen-15">
        <Loading />
      </div>
    );
  }

  if (access === 'no-bugo') {
    return <GiftStoreGateNotice variant="no-bugo" />;
  }

  // bugoId는 있으나 서버에 해당 부고가 없음(만료/오타/형식오류) → 안내
  if (access === 'invalid') {
    return <GiftStoreGateNotice variant="invalid" />;
  }

  if (access === 'closed') {
    return (
      <GiftStoreGateNotice variant="closed" deceasedName={deceasedName} bugoId={bugoId} />
    );
  }

  return <>{children}</>;
};

export default GiftStorePurchaseGate;
